export class InvoiceType {
  invoiceSalesAccountId: number;
  description: string;
}
